import React from 'react';
import Icon from '../../../components/AppIcon';


const TeamCollaboration = ({ currentLanguage }) => {
  const collaborationAreas = [
    {
      title: currentLanguage === 'en' ? 'Complex Corporate Transactions' : 'Miamala Magumu ya Makampuni',
      description: currentLanguage === 'en' ?'Peter and Judy collaborate on large-scale corporate mergers, acquisitions, and restructuring matters, combining their expertise in corporate law and regulatory compliance.' :'Peter na Judy wanashirikiana katika miamala mikubwa ya makampuni, uunganishaji, na marekebisho ya miundo, wakiunganisha utaalamu wao katika sheria ya makampuni na kufuata kanuni.',
      icon: 'Building2'
    },
    {
      title: currentLanguage === 'en' ? 'Multi-jurisdictional Cases' : 'Kesi za Mamlaka Nyingi',
      description: currentLanguage === 'en' ?'Our team approach ensures comprehensive coverage of cases spanning multiple legal jurisdictions, providing clients with seamless representation across different courts and regulatory bodies.' :'Mbinu yetu ya timu inahakikisha uwakilishi kamili wa kesi zinazoenea mamlaka mbalimbali za kisheria, ikiwapa wateja uwakilishi unaoendelea katika mahakama na vyombo mbalimbali vya udhibiti.',
      icon: 'Globe'
    },
    {
      title: currentLanguage === 'en' ? 'Strategic Legal Planning' : 'Mipango ya Kimkakati ya Kisheria',
      description: currentLanguage === 'en' ?'Together, we develop comprehensive legal strategies that address both immediate needs and long-term objectives, ensuring our clients receive well-rounded legal counsel.' :'Pamoja, tunaunda mikakati kamili ya kisheria inayoshughulikia mahitaji ya haraka na malengo ya muda mrefu, tukihakikisha wateja wetu wanapokea ushauri wa kisheria unaozingatia kila upande.',
      icon: 'Target'
    },
    {
      title: currentLanguage === 'en' ? 'Client Relationship Management' : 'Usimamizi wa Uhusiano wa Wateja',
      description: currentLanguage === 'en' ?'Our collaborative approach ensures that clients benefit from diverse perspectives and specialized knowledge, while maintaining consistent communication and service quality.' :'Mbinu yetu ya ushirikiano inahakikisha wateja wanafaidika na mitazamo mbalimbali na ujuzi maalum, huku tukidumisha mawasiliano thabiti na ubora wa huduma.',
      icon: 'Users'
    }
  ];

  const workflowSteps = [
    {
      step: 1,
      title: currentLanguage === 'en' ? 'Initial Consultation' : 'Mazungumzo ya Kwanza',
      description: currentLanguage === 'en' ?'Joint assessment of client needs and case complexity' :'Tathmini ya pamoja ya mahitaji ya mteja na ugumu wa kesi'
    },
    {
      step: 2,
      title: currentLanguage === 'en' ? 'Strategy Development' : 'Uundaji wa Mkakati',
      description: currentLanguage === 'en' ?'Collaborative planning and resource allocation' :'Mipango ya ushirikiano na ugawaji wa rasilimali'
    },
    {
      step: 3,
      title: currentLanguage === 'en' ? 'Execution & Monitoring' : 'Utekelezaji na Ufuatiliaji',
      description: currentLanguage === 'en' ?'Coordinated implementation with regular progress reviews' :'Utekelezaji ulioratibiwa na mapitio ya mara kwa mara ya maendeleo'
    },
    {
      step: 4,
      title: currentLanguage === 'en' ? 'Resolution & Follow-up' : 'Utatuzi na Ufuatiliaji',
      description: currentLanguage === 'en' ?'Comprehensive case closure and ongoing support' :'Mfungo kamili wa kesi na msaada unaoendelea'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg border border-border-light overflow-hidden">
      {/* Header */}
      <div className="p-6 lg:p-8 bg-gradient-to-r from-primary/10 to-accent/10 border-b border-border-light">
        <div className="text-center">
          <h2 className="text-2xl lg:text-3xl font-heading font-bold text-text-primary mb-3">
            {currentLanguage === 'en' ? 'Team Collaboration' : 'Ushirikiano wa Timu'}
          </h2>
          <p className="text-text-secondary leading-relaxed max-w-3xl mx-auto">
            {currentLanguage === 'en' ?'Peter and Judy work together seamlessly to provide comprehensive legal solutions. Their collaborative approach ensures that clients receive the full benefit of their combined expertise and experience.' :'Peter na Judy wanafanya kazi pamoja kwa urahisi kutoa suluhisho kamili za kisheria. Mbinu yao ya ushirikiano inahakikisha wateja wanapokea faida kamili ya utaalamu na uzoefu wao wa pamoja.'}
          </p>
        </div>
      </div>

      {/* Collaboration Areas */}
      <div className="p-6 lg:p-8">
        <h3 className="text-xl font-semibold text-text-primary mb-6 text-center">
          {currentLanguage === 'en' ? 'Key Collaboration Areas' : 'Maeneo Makuu ya Ushirikiano'}
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {collaborationAreas.map((area, index) => (
            <div key={index} className="p-6 bg-surface/10 rounded-lg border border-border-light">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                  <Icon name={area.icon} size={24} className="text-primary" />
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-text-primary mb-2">{area.title}</h4>
                  <p className="text-sm text-text-secondary leading-relaxed">{area.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Workflow Process */}
        <div className="bg-gradient-to-r from-surface/20 to-primary/10 rounded-lg p-6 lg:p-8">
          <h3 className="text-xl font-semibold text-text-primary mb-6 text-center">
            {currentLanguage === 'en' ? 'Our Collaborative Workflow' : 'Mchakato wetu wa Ushirikiano'}
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {workflowSteps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-4">
                  <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-white font-bold text-lg">{step.step}</span>
                  </div>
                  {index < workflowSteps.length - 1 && (
                    <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-primary/30 transform -translate-y-1/2"></div>
                  )}
                </div>
                <h4 className="font-semibold text-text-primary mb-2">{step.title}</h4>
                <p className="text-sm text-text-secondary">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Team Philosophy */}
        <div className="mt-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-xl font-semibold text-text-primary mb-4">
              {currentLanguage === 'en' ? 'Our Team Philosophy' : 'Falsafa yetu ya Timu'}
            </h3>
            <p className="text-text-secondary leading-relaxed mb-6">
              {currentLanguage === 'en'
                ? `At Peter & Partners Advocates LLP, we believe that the best legal outcomes are achieved through collaboration, not competition. Our team approach ensures that every client benefits from our collective knowledge, diverse perspectives, and shared commitment to excellence. We work together to deliver comprehensive solutions that address both the immediate legal challenges and the long-term strategic objectives of our clients.`
                : `Katika Peter & Partners Advocates LLP, tunaamini kwamba matokeo bora zaidi ya kisheria yanafikiwa kupitia ushirikiano, si ushindani. Mbinu yetu ya timu inahakikisha kila mteja anafaidika na maarifa yetu ya pamoja, mitazamo mbalimbali, na dhamira ya pamoja ya ubora. Tunafanya kazi pamoja kutoa suluhisho kamili zinazoshughulikia changamoto za haraka za kisheria na malengo ya kimkakati ya muda mrefu ya wateja wetu.`}
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle" size={20} className="text-success" />
                <span className="text-sm font-medium text-text-primary">
                  {currentLanguage === 'en' ? 'Collaborative Excellence' : 'Ubora wa Ushirikiano'}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={20} className="text-primary" />
                <span className="text-sm font-medium text-text-primary">
                  {currentLanguage === 'en' ? 'Client-Centered Approach' : 'Mbinu Inayolenga Mteja'}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Target" size={20} className="text-accent" />
                <span className="text-sm font-medium text-text-primary">
                  {currentLanguage === 'en' ? 'Strategic Solutions' : 'Suluhisho za Kimkakati'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamCollaboration;